var module = 'main', name = 'main/assets/images/spinner.svg', content = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9 -9 18 18\" preserveAspectRatio=\"xMidYMid meet\"><g class=\"spinner-g\"><circle cx=\"0\" cy=\"0\" r=\"50%\" width=\"100%\" height=\"100%\" fill=\"transparent\"></circle><path d=\"M0,0 m-8,0\n                a8,8 0 1,1 16,0\n                a8,8 0 1,1 -16,0\n                \" fill=\"transparent\" stroke-width=\"2px\" stroke-dasharray=\"50.3 50.3\" stroke-linecap=\"round\"></path></g></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/images/spinner.svg
// module id = 1286
// module chunks = 0